import httpClient from "./httpClient"; // Adjust the path if needed

const TeamsService = {
  async findAll(page = 1, pageSize = 100) {
    return await httpClient.get("/team", {
      params: { page, pageSize }
    });
  },

  async findById(id) {
    return await httpClient.get(`/team/${id}`);
  },

  async getByAnnouncement(announcementId) {
    return await httpClient.get(`/team/get-by-announcement/${announcementId}`);
  },

  async create(entity) {
    return await httpClient.post("/team", entity);
  },

  async update(entity) {
    return await httpClient.put(`/team/${entity.id}`, entity);
  },

  async addMember(teamId, memberId) {
    return await httpClient.post(`/team/${teamId}/members`, { memberId });
  },

  async removeMember(teamId, memberId) {
    return await httpClient.delete(`/team/${teamId}/members/${memberId}`);
  },

  async updateMembers(teamId, memberIds) {
    return await httpClient.put(`/team/${teamId}/members`, { members: memberIds });
  },

  async delete(id) {
    return await httpClient.delete(`/team/${id}`);
  },

  async archive(id) {
    return await httpClient.get("/team/archive", {
      params: {
        id,
        archived_by: localStorage.getItem("id")
      }
    });
  }
};

export default TeamsService;
